import { getData } from "app/data";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import RequestForm from "components/RequestForm/RequstForm";
import classes from "./TechUp.module.css";

const Index = () => {
  return (
    <Fragment>
      <section className={classes["hero-section"]}>
        <div className={classes["hero-wrapper"]}>
          <div className={classes["hero-background"]}>
            <div className={classes["hero-header"]}>
              <h2 className={classes["hero-subtitle-1"]}>
                {getData("techUp").hero.subtitle1}
              </h2>
              <div>
                <span className={classes["hero-title-white"]}>
                  {getData("techUp").hero.titleWhite}
                </span>
                <span className={classes["hero-title-yellow"]}>
                  {getData("techUp").hero.titleYellow}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={classes["main-section"]}>
        <div className={classes["main-contents-column"]}>
          <p className={classes["main-contents-para-before"]}>
            {getData("techUp").contents.para1_1}
          </p>
          <span className={classes["main-contents-para-span"]}>
            {getData("techUp").contents.para1_2}
          </span>
          <p className={classes["main-contents-para-after"]}>
            {getData("techUp").contents.para1_3}
          </p>
          <div className={classes.spacer}></div>
          <p className={classes["main-contents-para"]}>
            {getData("techUp").contents.para2}
          </p>
          <div className={classes["eligibility"]}>
            <h3 className={classes["main-contents-title"]}>
              {getData("techUp").contents.para3Title}
            </h3>
            <div className={classes["eligibility-contents"]}>
              <span className={classes["main-contents-para-before"]}>
                {getData("techUp").contents.para3_1}
              </span>
              <span className={classes["main-contents-para-bold"]}>
                {getData("techUp").contents.para3_2}
              </span>
            </div>
          </div>
          <div className={classes["costs"]}>
            <h3 className={classes["main-contents-title"]}>
              {getData("techUp").contents.para4Title}
            </h3>
            <p className={classes["main-contents-para-inline"]}>
              {getData("techUp").contents.para4}
            </p>
            <ul className={classes["main-contents-list"]}>
              {getData("techUp").contents.para4ListItem.map(item => (
                <li className={classes["main-contents-list-item"]} key={item}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className={classes["what-goopter-do"]}>
            <h3 className={classes["main-contents-title"]}>
              {getData("techUp").contents.para5Title}
            </h3>
            <p className={classes["main-contents-para-inline"]}>
              {getData("techUp").contents.para5}
            </p>
            <ul className={classes["main-contents-list"]}>
              <li
                className={classes["main-contents-list-item-bold"]}
                key={"what-goopter-do-1"}
              >
                {getData("techUp").contents.para5List1}
                <ul className={classes["main-contents-list"]}>
                  {getData("techUp").contents.para5List1Item.map(item => (
                    <li
                      className={classes["main-contents-list-item"]}
                      key={item}
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </li>
              <li
                className={classes["main-contents-list-item-bold"]}
                key={"what-goopter-do-2"}
              >
                {getData("techUp").contents.para5List2}
                <ul className={classes["main-contents-list"]}>
                  {getData("techUp").contents.para5List2Item.map(item => (
                    <li className={classes["main-contents-list-item"]}>
                      {item}
                    </li>
                  ))}
                </ul>
              </li>
              <li
                className={classes["main-contents-list-item"]}
                key={"what-goopter-do-3"}
              >
                {getData("techUp").contents.para5List3}
              </li>
            </ul>
            <div className={`green-button ${classes["button"]}`}>
              <Link to="/features-business">
                {getData("goDigital").contents.button}
              </Link>
            </div>
          </div>
        </div>
        <div className={classes["main-form-column"]}>
          <RequestForm
            formHeader={getData("techUp").form.header}
            optionalSelect={getData("techUp").form.select}
            optionalSelectOptions={getData("techUp").form.options}
            formId={361}
          />
        </div>
      </section>
    </Fragment>
  );
};

export default Index;
